import React, { useState } from 'react'
import { NoData } from '../../Assets/Images/icons/noData'
import injectStyles from 'react-jss'
import { styles } from './styles'

const Tooltip = ({ content, classes, hintPosition }) => {
  const [show, setShow] = useState(false)

  return (
    <div
      className={classes.container}
      onMouseOver={() => setShow(true)}
      onMouseOut={() => setShow(false)}
    >
      <NoData fill="#011533" />
      {show && (
        <div>
          <div
            className={
              hintPosition === 'left' ? classes.modalLeft : classes.modal
            }
          >
            <div className={classes.logo}>
              <NoData width="15" height="15" />
            </div>
            {content}
          </div>
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(Tooltip)
